export const PROGRAM_STRUCTURE_3_CONSTANTS = {
  PROGRAM_STRUCTURE_3_FIELDS_CONFIG: [
    {
      fieldName: "section_background_image",
      label: "Section background image",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Upload full-bleed background",
      required: false,
      defaultValue: "",
      filterCategory: "images",
    },
    {
      fieldName: "section_background_image_alt",
      label: "Background image alt text",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Describe the image",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "section_overlay_rgba",
      label: "Image overlay (RGBA, optional)",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Leave empty for no overlay, or e.g. rgba(0,0,0,0.45)",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "headline_primary",
      label: "Headline (first line)",
      value: "The Complete Curriculum -",
      valueType: "string",
      filedType: "TEXTAREA",
      placeholder: "",
      required: false,
      defaultValue: "The Complete Curriculum -",
      rows: 2,
    },
    {
      fieldName: "headline_primary_color",
      label: "Headline first line color",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      required: false,
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "headline_accent",
      label: "Headline (accent line)",
      value: "A Structured Path to Your Program",
      valueType: "string",
      filedType: "TEXTAREA",
      placeholder: "",
      required: false,
      defaultValue: "A Structured Path to Your Program",
      rows: 2,
    },
    {
      fieldName: "headline_accent_color",
      label: "Headline accent color",
      value: "#F5C542",
      valueType: "string",
      filedType: "COLOR",
      required: false,
      defaultValue: "#F5C542",
    },
    {
      fieldName: "topics_column_title",
      label: "Right column — main title",
      value: "Topic Covered",
      valueType: "string",
      filedType: "INPUT",
      required: false,
      defaultValue: "Topic Covered",
    },
    {
      fieldName: "topics_inner_heading",
      label: "Right column — inner heading",
      value: "Topics",
      valueType: "string",
      filedType: "INPUT",
      required: false,
      defaultValue: "Topics",
    },
    {
      fieldName: "card_background_color",
      label: "Main card background",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      required: false,
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "module_list_track_background_color",
      label: "Desktop — module list panel background",
      value: "#E8EAED",
      valueType: "string",
      filedType: "COLOR",
      required: false,
      defaultValue: "#E8EAED",
    },
    {
      fieldName: "content_panel_background_color",
      label: "Right panel (topics box) background",
      value: "#F3F4F6",
      valueType: "string",
      filedType: "COLOR",
      required: false,
      defaultValue: "#F3F4F6",
    },
    {
      fieldName: "module_inactive_border_color",
      label: "Module row border",
      value: "#E5E7EB",
      valueType: "string",
      filedType: "COLOR",
      required: false,
      defaultValue: "#E5E7EB",
    },
    {
      fieldName: "module_list_divider_color",
      label: "Divider line between modules (left column)",
      value: "#94A3B8",
      valueType: "string",
      filedType: "COLOR",
      required: false,
      defaultValue: "#94A3B8",
    },
    {
      fieldName: "module_active_background_color",
      label: "Selected module background",
      value: "#FF6B00",
      valueType: "string",
      filedType: "COLOR",
      required: false,
      defaultValue: "#FF6B00",
    },
    {
      fieldName: "module_active_text_color",
      label: "Selected module text",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      required: false,
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "module_inactive_text_color",
      label: "Module text (inactive)",
      value: "#111827",
      valueType: "string",
      filedType: "COLOR",
      required: false,
      defaultValue: "#111827",
    },
    {
      fieldName: "section_background_color",
      label: "Fallback background (when no image)",
      value: "#0B0F14",
      valueType: "string",
      filedType: "COLOR",
      required: false,
      defaultValue: "#0B0F14",
    },
    {
      fieldName: "cta_button_text",
      label: "CTA label",
      value: "Apply Now",
      valueType: "string",
      filedType: "INPUT",
      required: false,
      defaultValue: "Apply Now",
    },
    {
      fieldName: "cta_button_text_color",
      label: "CTA text color",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      required: false,
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "cta_button_color",
      label: "CTA background",
      value: "#FF6B00",
      valueType: "string",
      filedType: "COLOR",
      required: false,
      defaultValue: "#FF6B00",
    },
    {
      fieldName: "cta_button_is_cta",
      label: "Is CTA — Primary (lead popup)",
      value: true,
      valueType: "boolean",
      filedType: "TOGGLE",
      placeholder:
        "On = lead capture popup; off = direct course brochure URL (needs brochure on course)",
      required: false,
      defaultValue: true,
    },
    {
      fieldName: "brochure_cta_text",
      label: "Download brochure — label (empty = hide)",
      value: "Download Brochure",
      valueType: "string",
      filedType: "INPUT",
      required: false,
      defaultValue: "Download Brochure",
    },
    {
      fieldName: "brochure_cta_text_color",
      label: "Download brochure — text & icon",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      required: false,
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "brochure_cta_border_color",
      label: "Download brochure — border",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      required: false,
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "brochure_cta_is_cta",
      label: "Is CTA — Download brochure (lead popup)",
      value: true,
      valueType: "boolean",
      filedType: "TOGGLE",
      placeholder:
        "On = lead capture popup then download; off = open course brochure URL directly",
      required: false,
      defaultValue: true,
    },
    {
      fieldName: "status",
      label: "Section status",
      value: false,
      valueType: "boolean",
      filedType: "TOGGLE",
      required: false,
      defaultValue: false,
    },
  ],

  METADATA_TITLES: {
    metadata: "Modules",
  },

  METADATA_FIELDS: [
    {
      header: "Module title",
      fieldName: "module_title",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "e.g. Module 1: Foundations",
      required: false,
    },
    {
      header: "Topics (HTML)",
      fieldName: "topics_html",
      value: "",
      valueType: "string",
      filedType: "TEXTAREA",
      placeholder:
        "Each <p>…</p>, <li>…</li>, or top-level <div> gets a divider below it. Example: <p>Point one</p><p>Point two</p>",
      required: false,
      rows: 5,
    },
    {
      header: "Sort order",
      fieldName: "priority",
      value: 0,
      valueType: "number",
      filedType: "INPUT",
      placeholder: "0",
      required: false,
      defaultValue: 0,
    },
    {
      header: "Active",
      fieldName: "status",
      value: true,
      valueType: "boolean",
      filedType: "TOGGLE",
      required: false,
      defaultValue: true,
    },
  ],

  DEFAULT_ROW: {
    module_title: "",
    topics_html: "",
    priority: 0,
    status: true,
  },
};
